import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/services/user.service';
import { User } from 'app/core/types/user.types';

const DESIGN_SYSTEM_LOGINS = new Set(['DE', 'SAS']);

export function canSeeDesignSystem(user: User | undefined): boolean {
    return DESIGN_SYSTEM_LOGINS.has(user?.login?.trim().toUpperCase() ?? '');
}

export const designSystemGuard: CanActivateFn = () =>
    canSeeDesignSystem(inject(UserService).getUser()) ||
    inject(Router).createUrlTree(['/home']);
